/**
 * Keeps RevenueCat appUserID in sync with the logged-in artist.
 */

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import {
  initRevenueCatForSession,
  logOutRevenueCat,
} from '@/services/revenueCatService';
import { useRevenueCatAppUserId } from '@/hooks/useRevenueCatAppUserId';

export function useRevenueCatSession(): void {
  const appUserId = useRevenueCatAppUserId();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !appUserId) {
      void logOutRevenueCat();
      return;
    }
    void initRevenueCatForSession(appUserId);
  }, [isAuthenticated, appUserId]);
}
